var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconClockClockwise = function SvgIconClockClockwise(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.222 5.301a7.25 7.25 0 0 1 7.902 1.575h.001l1.474 1.47h-1.33a1 1 0 1 0 0 2h3.75a1 1 0 0 0 1-1.011V5.597a1 1 0 0 0-2 0v1.34l-1.48-1.475h-.001a9.25 9.25 0 1 0 0 13.076 1 1 0 1 0-1.414-1.414A7.25 7.25 0 1 1 9.222 5.301"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 7.5a1 1 0 1 0-2 0v4.48a1.01 1.01 0 0 0 .416.832q.049.035.1.064l3.884 2.24a1 1 0 1 0 1-1.732L13 11.422z"
  }))));
};
export default SvgIconClockClockwise;